var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnecting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        .connecting-st0{fill:#FFFFFF;stroke:currentColor;stroke-width:8;stroke-miterlimit:10;}\r\n        .connecting-st1{fill:#FFFFFF;stroke:currentColor;stroke-width:8.2257;stroke-miterlimit:10;}\r\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "connecting-st0",
    cx: 304.5,
    cy: 180,
    r: 32
  }), /*#__PURE__*/React.createElement("path", {
    className: "connecting-st1",
    d: "M277.7,169.4h-192c0,0,0,0,0,0c-4.6-13.2-17.6-22.4-32.6-21.4c-15.7,1.1-28.5,13.9-29.6,29.6 C22.3,196.4,37.1,212,55.5,212c14.1,0,26.1-9.1,30.3-21.8c0,0,0,0,0,0h191.9c4.1-4.1,6.3-6.3,10.4-10.4v0 C284.1,175.8,281.8,173.5,277.7,169.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnecting);
export default __webpack_public_path__ + "static/media/connecting.25a222f24ea8bb2baad41057c3bac7df.svg";
export { ForwardRef as ReactComponent };